<template>
  <div class="content-container">
    <div class="breadcrumb-wrapper clearfix"></div>
    <div class="paper-container clearfix">
      <div class="paper-main fl">
        <div v-if="isLoading" class="loading-box font-12 column">
          <div class="c-40b8ee mt50">
            <i class="el-icon-loading"></i
            ><span class="loading-text">拼命加载中</span>
          </div>
        </div>
        <template v-else>
          <div
            class="paper-seal"
            v-show="styleCheckList.indexOf('isShowLine') > -1"
          >
            <div class="test-input">
              <div class="item">
                <span class="text">学校：</span><em class="line"></em>
              </div>
              <div class="item">
                <span class="text">姓名：</span><em class="line"></em>
              </div>
              <div class="item">
                <span class="text">班级：</span><em class="line"></em>
              </div>
              <div class="item">
                <span class="text">考号：</span><em class="line"></em>
              </div>
            </div>
            <div class="line-text color-9 font-12">
              密封线内不要答题
            </div>
          </div>
          <div class="paper-content">
            <div class="paper-header">
              <div class="marktag-box">
                <div
                  class="test-marktag font-b"
                  v-show="styleCheckList.indexOf('isShowSecretSign') > -1"
                >
                  <!-- 绝密★启用前 -->
                  <input
                    ref="secretSign"
                    type="text"
                    maxlength="20"
                    class="edit-input"
                    v-if="preview.isSecretSign"
                    v-model="preview.secretSign"
                    @blur="blurEditField('secretSign', 'isSecretSign')"
                  />
                  <span
                    class="edit-text"
                    v-else
                    @click="onEditField('isSecretSign', 'secretSign')"
                  >
                    {{ preview.secretSign }}
                  </span>
                </div>
              </div>
              <div class="test-title">
                <h1
                  class="head-title color-3 font-20 font-b"
                  v-show="styleCheckList.indexOf('isShowPaperHeadline') > -1"
                >
                  <!-- 试卷主标题 -->
                  <input
                    ref="paperHeadline"
                    type="text"
                    maxlength="50"
                    class="edit-input"
                    v-model="preview.paperHeadline"
                    @blur="blurEditField('paperHeadline', 'isPaperHeadline')"
                    v-if="preview.isPaperHeadline"
                  />
                  <span
                    class="edit-text"
                    @click="onEditField('isPaperHeadline', 'paperHeadline')"
                    v-else
                  >
                    {{ preview.paperHeadline }}
                  </span>
                </h1>
                <h2
                  class="sub-title color-3 font-16 font-b"
                  v-show="styleCheckList.indexOf('isShowPaperSubtitle') > -1"
                >
                  <!-- 试卷副标题 -->
                  <input
                    ref="paperSubtitle"
                    type="text"
                    maxlength="50"
                    class="edit-input"
                    v-model="preview.paperSubtitle"
                    @blur="blurEditField('paperSubtitle', 'isPaperSubtitle')"
                    v-if="preview.isPaperSubtitle"
                  />
                  <span
                    class="edit-text"
                    @click="onEditField('isPaperSubtitle', 'paperSubtitle')"
                    v-else
                  >
                    {{ preview.paperSubtitle }}
                  </span>
                </h2>
              </div>
              <div
                class="test-time color-9 font-12"
                v-show="styleCheckList.indexOf('isShowPaperInfo') > -1"
              >
                <span class="item" v-for="v in paperInfo" :key="v.name">
                  {{ v.name }}： <em class="edit-text"> {{ v.input_value }} </em
                  ><input
                    type="text"
                    maxlength="10"
                    class="edit-input"
                    v-model="v.input_value"
                    style="display: none;"
                /></span>
              </div>
              <div
                class="test-input color-6"
                v-show="styleCheckList.indexOf('isShowStudentInput') > -1"
              >
                {{ preview.studentInput }}
              </div>
              <div
                class="test-score"
                v-show="styleCheckList.indexOf('isShowPerformance') > -1"
              >
                <table cellspacing="0" cellpadding="0" class="score-table">
                  <tbody>
                    <tr>
                      <th>题号</th>
                      <th v-for="item in oneList['list']" :key="item.id">
                        {{ item.ordinal | texeNum }}
                      </th>
                      <th v-for="(item, index) in twoList['list']" :key="index">
                        {{ item.ordinal | texeNum }}
                      </th>
                      <th>总分</th>
                    </tr>
                    <tr>
                      <td>得分</td>
                      <th v-for="item in oneList['list']" :key="item.id">
                        &nbsp;
                      </th>
                      <th v-for="(item, index) in twoList['list']" :key="index">
                        &nbsp;
                      </th>
                      <td>&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                class="test-rule font-12"
                v-show="styleCheckList.indexOf('isShowPayAttention') > -1"
              >
                <h3 class="rule-title">*注意事项：</h3>
                <div class="rule-text">
                  <textarea
                    ref="payAttention"
                    type="text"
                    maxlength="50"
                    class="edit-input"
                    v-model="preview.payAttention"
                    @blur="blurEditField('payAttention', 'isPayAttention')"
                    v-if="preview.isPayAttention"
                  ></textarea>
                  <span
                    class="edit-text"
                    @click="onEditField('isPayAttention', 'payAttention')"
                    v-else
                  >
                    {{ preview.payAttention }}
                  </span>
                </div>
              </div>
            </div>
            <div class="paper-body f-usn">
              <div class="paper-part">
                <div
                  class="paper-title"
                  v-show="styleCheckList.indexOf('isShowPaperGroup') > -1"
                >
                  <div class="title color-3 font-16">
                    <input
                      ref="paperGroupNameOne"
                      type="text"
                      maxlength="20"
                      class="edit-input"
                      v-model="oneList.name"
                      @blur="
                        blurEditField(
                          'paperGroupNameOne',
                          'isPaperGroupNameOne'
                        )
                      "
                      v-if="preview.isPaperGroupNameOne"
                    />
                    <span
                      class="edit-text"
                      @click="onEditField('isPaperGroupNameOne', 'paperGroupNameOne')"
                      v-else
                    >
                      {{ oneList.name }}
                    </span>
                  </div>
                  <p class="paper-rule font-12">
                    <input
                      ref="paperGroupDescOne"
                      type="text"
                      maxlength="20"
                      class="edit-input"
                      v-model="oneList.desc"
                      @blur="
                        blurEditField(
                          'paperGroupDescOne',
                          'isPaperGroupDescOne'
                        )
                      "
                      v-if="preview.isPaperGroupDescOne"
                    />
                    <span
                      class="edit-text"
                      @click="onEditField('isPaperGroupDescOne', 'paperGroupDescOne')"
                      v-else
                    >
                      {{ oneList.desc }}
                    </span>
                  </p>
                </div>
                <div
                  class="paper-section"
                  v-for="(item, key) in oneList['list']"
                  :key="key"
                >
                  <div class="question-type">
                    <table
                      cellspacing="0"
                      cellpadding="0"
                      class="score-table"
                      v-show="styleCheckList.indexOf('isShowGroupScore') > -1"
                    >
                      <tbody>
                        <tr>
                          <th>评卷人</th>
                          <th>得分</th>
                        </tr>
                        <tr>
                          <td>&nbsp;</td>
                          <td>&nbsp;</td>
                        </tr>
                      </tbody>
                    </table>
                    <h4
                      class="type-title color-3"
                      v-show="styleCheckList.indexOf('isShowGroupDesc') > -1"
                    >
                      <span class="order">{{ item.ordinal | texeNum }}.</span
                      ><span class="edit-text">
                        {{ item.questionTypeName }} </span
                      ><input
                        type="text"
                        maxlength="10"
                        class="edit-input"
                        style="display: none;"
                      /><span
                        >（共
                        <strong class="num">{{ item.count }}</strong>
                        小题）</span
                      >
                    </h4>
                  </div>
                  <div>
                    <div v-for="(v, k) in item.list" :key="k">
                      <div class="question-wrapper">
                        <div class="question-container">
                          <div class="question-content">
                            <div class="ques-origin">
                              <div>
                                <div class="ques-topic">
                                  <span
                                    class="ques-type"
                                    v-html="
                                      numHtml(
                                        v.ordinal,
                                        v.questionInfo.context.stem
                                      )
                                    "
                                  ></span>
                                </div>
                              </div>
                              <ul
                                class="ques-option"
                                style="display: flex; align-items: flex-end; flex-wrap: wrap;"
                                v-if="v.questionInfo.context.options"
                              >
                                <li
                                  v-for="(n, i) in v.questionInfo.context
                                    .options"
                                  :key="i"
                                  v-html="optionHtml(i, n)"
                                ></li>
                              </ul>
                            </div>
                            <template v-if="v.questionInfo.children.length > 0">
                              <div
                                v-for="(val, key) in v.questionInfo.children"
                                :key="key"
                              >
                                <div class="ques-origin">
                                  <div>
                                    <div class="ques-topic">
                                      <span
                                        class="ques-type"
                                        v-html="val.context.stem"
                                      ></span>
                                    </div>
                                  </div>
                                  <ul
                                    class="ques-option"
                                    style="display: flex; align-items: flex-end; flex-wrap: wrap;"
                                    v-if="val.context.options"
                                  >
                                    <li
                                      v-for="(n, i) in val.context.options"
                                      :key="i"
                                      v-html="optionHtml(i, n)"
                                    ></li>
                                  </ul>
                                </div>
                              </div>
                            </template>
                          </div>
                          <div class="question-operate clearfix">
                            <div class="operate-item operate-item-set">
                              <div
                                class="cp-number-input operate-cp-number-input el-input"
                              >
                                <input
                                  type="text"
                                  autocomplete="off"
                                  placeholder=""
                                  class="el-input__inner"
                                />
                              </div>
                              <span class="operate-text color-9 font-12"
                                >分</span
                              >
                            </div>
                            <div class="operate-item">
                              <span class="operate-btn check-btn">详情</span>
                            </div>
                            <div class="operate-item">
                              <span class="operate-btn check-btn">上移</span>
                            </div>
                            <div class="operate-item">
                              <span class="operate-btn check-btn">下移</span>
                            </div>
                            <div class="operate-item">
                              <span class="operate-btn delete-btn">删除</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="paper-part">
                <div
                  class="paper-title"
                  v-show="styleCheckList.indexOf('isShowPaperGroup') > -1"
                >
                  <div class="title color-3 font-16">
                    <input
                      ref="paperGroupNameTwo"
                      type="text"
                      maxlength="20"
                      class="edit-input"
                      v-model="twoList.name"
                      @blur="
                        blurEditField(
                          'paperGroupNameTwo',
                          'isPaperGroupNameTwo'
                        )
                      "
                      v-if="preview.isPaperGroupNameTwo"
                    />
                    <span
                      class="edit-text"
                      @click="onEditField('isPaperGroupNameTwo', 'paperGroupNameTwo')"
                      v-else
                    >
                      {{ twoList.name }}
                    </span>
                  </div>
                  <p class="paper-rule font-12">
                    <input
                      ref="paperGroupDescTwo"
                      type="text"
                      maxlength="20"
                      class="edit-input"
                      v-model="twoList.desc"
                      @blur="
                        blurEditField(
                          'paperGroupDescTwo',
                          'isPaperGroupDescTwo'
                        )
                      "
                      v-if="preview.isPaperGroupDescTwo"
                    />
                    <span
                      class="edit-text"
                      @click="onEditField('isPaperGroupDescTwo', 'paperGroupDescTwo')"
                      v-else
                    >
                      {{ twoList.desc }}
                    </span>
                  </p>
                </div>
                <div
                  class="paper-section"
                  v-for="(item, index) in twoList['list']"
                  :key="index"
                >
                  <div class="question-type">
                    <table cellspacing="0" cellpadding="0" class="score-table">
                      <tbody>
                        <tr>
                          <th>评卷人</th>
                          <th>得分</th>
                        </tr>
                        <tr>
                          <td>&nbsp;</td>
                          <td>&nbsp;</td>
                        </tr>
                      </tbody>
                    </table>
                    <h4 class="type-title color-3">
                      <span class="order">{{ item.ordinal | texeNum }}.</span
                      ><span class="edit-text">
                        {{ item.questionTypeName }} </span
                      ><input
                        type="text"
                        maxlength="10"
                        class="edit-input"
                        style="display: none;"
                      /><span
                        >（共
                        <strong class="num">{{ item.count }}</strong>
                        小题）</span
                      >
                    </h4>
                  </div>
                  <div>
                    <div v-for="(v, k) in item.list" :key="k">
                      <div class="question-wrapper">
                        <div class="question-container">
                          <div class="question-content">
                            <div class="ques-origin">
                              <div>
                                <div class="ques-topic">
                                  <span
                                    class="ques-type"
                                    v-html="
                                      numHtml(
                                        v.ordinal,
                                        v.questionInfo.context.stem
                                      )
                                    "
                                  ></span>
                                </div>
                              </div>
                              <ul
                                class="ques-option"
                                style="display: flex; align-items: flex-end; flex-wrap: wrap;"
                                v-if="v.questionInfo.context.options"
                              >
                                <li
                                  v-for="(n, i) in v.questionInfo.context
                                    .options"
                                  :key="i"
                                  v-html="optionHtml(i, n)"
                                ></li>
                              </ul>
                            </div>
                            <template v-if="v.questionInfo.children.length > 0">
                              <div
                                v-for="(val, key) in v.questionInfo.children"
                                :key="key"
                              >
                                <div class="ques-origin">
                                  <div>
                                    <div class="ques-topic">
                                      <span
                                        class="ques-type"
                                        v-html="val.context.stem"
                                      ></span>
                                    </div>
                                  </div>
                                  <ul
                                    class="ques-option"
                                    style="display: flex; align-items: flex-end; flex-wrap: wrap;"
                                    v-if="val.context.options"
                                  >
                                    <li
                                      v-for="(n, i) in val.context.options"
                                      :key="i"
                                      v-html="optionHtml(i, n)"
                                    ></li>
                                  </ul>
                                </div>
                              </div>
                            </template>
                          </div>
                          <div class="question-operate clearfix">
                            <div class="operate-item operate-item-set">
                              <div
                                class="cp-number-input operate-cp-number-input el-input"
                              >
                                <input
                                  type="text"
                                  autocomplete="off"
                                  placeholder=""
                                  class="el-input__inner"
                                />
                              </div>
                              <span class="operate-text color-9 font-12"
                                >分</span
                              >
                            </div>
                            <div class="operate-item">
                              <span class="operate-btn check-btn">详情</span>
                            </div>
                            <div class="operate-item">
                              <span class="operate-btn check-btn">上移</span>
                            </div>
                            <div class="operate-item">
                              <span class="operate-btn check-btn">下移</span>
                            </div>
                            <div class="operate-item">
                              <span class="operate-btn delete-btn">删除</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="paper-body-close-view">
          <i class="iconfont iconguanbiyulan"></i><span>关闭预览</span>
        </div> -->
        </template>
      </div>
      <div class="paper-side fl">
        <div class="paper-operate">
          <div class="item item-save">
            <button
              type="button"
              class="el-button btn btn-border el-button--default"
            >
              <span>分值设置</span>
            </button>
            <!-- <button
              
              type="button"
              class="el-button btn btn-border el-button--default"
            >
              <span>试卷分析</span>
            </button> -->
          </div>
          <div class="item item-save">
            <button
              type="button"
              class="el-button btn btn-border el-button--default"
            >
              <span>下载试卷</span>
            </button>
          </div>
          <div class="item item-save">
            <button type="button" class="el-button btn el-button--default">
              <span>保存试卷</span>
            </button>
          </div>
        </div>
        <div class="paper-set">
          <h3 class="set-title color-3 font-16">参数设置</h3>
          <div class="set-items">
            <el-radio-group
              v-model="formStyle.styleTypes"
              @change="onStyleTypes"
            >
              <el-radio
                :label="style.id"
                v-for="style in styleTypeList"
                :key="style.id"
                >{{ style.name }}</el-radio
              >
            </el-radio-group>
          </div>
          <div class="set-options">
            <el-checkbox-group v-model="styleCheckList">
              <el-checkbox
                v-for="(item, index) in styleList"
                :key="index"
                :label="item.type"
                class="style-item"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </div>
        <div class="paper-edit">
          <div class="edit-header">
            <h3 class="edit-title color-3 font-16">试题统计</h3>
            <span class="paper-empty"
              ><i class="iconfont iconnonebg-delete"></i
              ><span class="text">清空</span></span
            >
          </div>
          <div class="edit-sum">
            <span class="item">分数：<em class="num">0</em></span
            ><span class="item">题数：<em class="num">4</em></span>
          </div>
          <div class="edit-body">
            <div class="edit-part">
              <div
                class="group-name color-3 font-b"
                v-show="styleCheckList.indexOf('isShowPaperGroup') > -1"
              >
                第 I 卷（选择题）
              </div>
              <div>
                <div
                  class="edit-item"
                  v-for="(item, index) in oneList['list']"
                  :key="index"
                >
                  <div class="edit-item-top">
                    <strong class="type color-3"
                      ><span class="order">{{ item.ordinal | texeNum }}. </span
                      ><span class="text">{{
                        item.questionTypeName
                      }}</span></strong
                    >
                    <div class="edit-operate">
                      <span class="operate-btn delete-btn">删除</span>
                    </div>
                  </div>
                  <div class="edit-item-content">
                    <ul class="item-num-body clearfix">
                      <li class="item-num-box J_drag_grid">
                        <span class="num">1</span>
                      </li>
                      <li class="item-num-box J_drag_grid">
                        <span class="num">2</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-part">
              <div
                class="group-name color-3 font-b"
                v-show="styleCheckList.indexOf('isShowPaperGroup') > -1"
              >
                第 II 卷（非选择题）
              </div>
              <div>
                <div
                  class="edit-item"
                  v-for="(item, index) in twoList['list']"
                  :key="index"
                >
                  <div class="edit-item-top">
                    <strong class="type color-3"
                      ><span class="order">{{ item.ordinal | texeNum }}. </span
                      ><span class="text">{{
                        item.questionTypeName
                      }}</span></strong
                    >
                    <div class="edit-operate">
                      <span class="operate-btn delete-btn">删除</span>
                    </div>
                  </div>
                  <div class="edit-item-content">
                    <ul class="item-num-body clearfix">
                      <li
                        class="item-num-box J_drag_grid"
                        v-for="(v, k) in item.list"
                        :key="k"
                      >
                        <span class="num">{{ v.ordinal }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="edit-footer">
            <button
              type="button"
              class="el-button btn btn-light el-button--default"
            >
              <!----><!----><span>继续选题</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      isLoading: true,
      list: [],
      //参数设置类型列表
      styleTypeList: [
        { name: "作业", id: 1 },
        { name: "测试", id: 2 },
        { name: "考试", id: 3 },
      ],
      styleList: [
        { name: "主标题", type: "isShowPaperHeadline" },
        { name: "副标题", type: "isShowPaperSubtitle" },
        { name: "试卷信息", type: "isShowPaperInfo" },
        { name: "考生输入栏", type: "isShowStudentInput" },
        { name: "誊分栏", type: "isShowPerformance" },
        { name: "注意事项", type: "isShowPayAttention" },
        { name: "装订线", type: "isShowLine" },
        { name: "分卷及注释", type: "isShowPaperGroup" },
        { name: "保密标记", type: "isShowSecretSign" },
        { name: "大题评分区", type: "isShowGroupScore" },
        { name: "大题说明", type: "isShowGroupDesc" },
      ],
      paperInfo: [
        { name: "考试范围", input_value: "xxx" },
        { name: "考试时间", input_value: "100分钟" },
        { name: "命题人", input_value: "xxx" },
      ],
      //设置类型初始设置
      styleCheckListInit: [
        ["isShowPaperHeadline", "isShowPaperSubtitle", "isShowGroupDesc"],
        [
          "isShowPaperHeadline",
          "isShowPaperInfo",
          "isShowStudentInput",
          "isShowGroupScore",
          "isShowGroupDesc",
        ],
        [
          "isShowPaperHeadline",
          "isShowPaperSubtitle",
          "isShowPaperInfo",
          "isShowStudentInput",
          "isShowPerformance",
          "isShowPayAttention",
          "isShowLine",
          "isShowSecretSign",
          "isShowGroupScore",
          "isShowGroupDesc",
        ],
      ],
      styleCheckList: [],
      formStyle: {
        styleTypes: 1,
        isShowPaperHeadline: 1,
        isShowPaperSubtitle: 1,
        isShowPaperInfo: 1,
        isShowStudentInput: 1,
        isShowPerformance: 1,
        isShowPayAttention: 1,
        isShowLine: 1,
        isShowPaperGroup: 0,
        isShowSecretSign: 1,
        isShowGroupScore: 1,
        isShowGroupDesc: 1,
      },
      preview: {},
      oneList: [],
      twoList: [],
    };
  },
  computed: {
    ...mapState(["stageSubject"]),
  },
  created() {
    this.stageCode =
      this.$route.query.stagecode || this.stageSubject.stage.code;
    this.subjectCode =
      this.$route.query.subjectcode || this.stageSubject.subject.code;
    this.styleCheckList = this.styleCheckListInit[2];
    this.getPreview();
  },
  filters: {
    texeNum: function(v) {
      let numList = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二",
        "十三",
        "十四",
        "十五",
        "十六",
        "十七",
        "十八",
        "十九",
        "二十",
      ];
      return numList[+v];
    },
  },
  methods: {
    getPreview() {
      this.getRequest("/wenjiaoopne/kc/basket/preview", {
        stage: this.stageSubject.stage.code,
        subject: this.stageSubject.subject.code,
      })
        .then((result) => {
          this.preview = result.data;
          this.oneList = this.preview.list[0];
          this.twoList = this.preview.list[1];
          this.isLoading = false;
        })
        .catch(() => {});
    },
    onStyleTypes(v) {
      this.formStyle.styleTypes = v;
      this.styleCheckList = this.styleCheckListInit[--v];
    },
    onEditField(field, refName) {
      console.log(field, refName);
      this.editFieldOld = this.preview[refName];
      this.$set(this.preview, field, true);
      this.$nextTick(() => {
        this.$refs[refName].focus();
      });
    },

    blurEditField(field, isField) {
      console.log(this.preview[field], this.editFieldOld);
      this.$set(this.preview, isField, false);
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/browse.css";
</style>
